import BaseUseCase from "../../../base_use_case.js";

class SaveCompanyUseCase extends BaseUseCase {

  execute(identifier, params) {
    let url = identifier ? `/api/v1/admin/companies/companies/${identifier}` : `/api/v1/admin/companies/companies`;

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: this.wrapParams(params, "company"),
    });
  }
}

const instance = new SaveCompanyUseCase();
export default instance;